import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionWebhookMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemWebhookMapping({ id, params }) {
  return request(`/actionWebhookMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewWebhookMapping(params) {
  return request.post(`/actionWebhookMapping`, {
    data: params,
  });
}

export async function queryAddEditWebhookMapping(params) {
  return request.put('/actionWebhookMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionWebhookMapping/${id}`, {});
}
